
import { Home, FileText, ClipboardList, CreditCard, BadgeHelp } from "lucide-react";
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar";
import { Link } from "react-router-dom";

const UserMenu = () => {
  const menuItems = [
    {
      title: "Dashboard Home",
      icon: Home,
      href: "/dashboard",
    },
    {
      title: "My Policies",
      icon: FileText,
      href: "/dashboard/my-policies",
    },
    {
      title: "Claims",
      icon: ClipboardList,
      href: "/dashboard/claims",
    },
    {
      title: "ID Cards",
      icon: BadgeHelp,
      href: "/dashboard/id-cards",
    },
    {
      title: "Payments",
      icon: CreditCard,
      href: "/dashboard/payments",
    },
  ];

  return (
    <SidebarMenu>
      {menuItems.map((item) => (
        <SidebarMenuItem key={item.title}>
          <SidebarMenuButton asChild>
            <Link 
              to={item.href}
              className="hover:bg-primary/10 rounded-md px-2 py-1 transition-all duration-200"
            >
              <item.icon className="h-4 w-4 text-primary hover:scale-110 transition-transform duration-200" />
              <span className="hover:text-primary transition-colors duration-200">{item.title}</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
};

export default UserMenu;

